import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import React from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/system';
import brush from '../../sources/Graph/Brush_green.png';
import image_Intro from '../../sources/Graph/Image_Intro02.png';
/*
import Link from '@mui/material/Link';
import GooglePlayLogo from '../../sources/Icon/GooglePlay.png';
import AppStoreLogo from '../../sources/Icon/AppStore.png';
*/
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// 定义高级、优雅的"淡入且缓慢上浮"进入动画
const imageReveal = keyframes`
  0% {
    opacity: 0;
    transform: translate(4%, 4%); /* 初始偏下并隐藏 */
    filter: blur(8px); /* 细微的高斯模糊增加呼吸感 */
  }
  100% {
    opacity: 1;
    transform: translate(4%, -4%); /* 回到我们设定的右上方 */
    filter: blur(0px); /* 变清晰 */
  }
`;

export default function Introduction() {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const introTitle = t('Introduction.title');
    const [introTitleFirstLine, ...introTitleRemainingLines] = introTitle.split('\n');
    const hasSeparatedTitle = introTitleRemainingLines.length > 0;

    return (
        <Grid container direction={isMobile ? "column" : "row"} sx={{
            justifyContent: "center",
            alignItems: "center",
            padding: { xs: 2, md: 0 }
        }}>
            <Grid item xs={12} md={4} container direction={'column'} sx={{
                order: { xs: 2, md: 1 },
                textAlign: { xs: 'center', md: 'left' }
            }}>
                <Box sx={{ width: '100%' }}>
                    <Typography
                        fontFamily={"Lava Telugu"}
                        sx={{
                            width: '100%',
                            fontSize: { xs: '36px', sm: '50px', md: '64px' },
                            fontWeight: 700,
                            fontStyle: "normal",
                            color: 'white',
                            py: { xs: 2, md: 3 },
                            textAlign: { xs: 'center', md: 'left' },
                            textShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
                            lineHeight: '100%',
                            position: 'relative',
                            backgroundImage: hasSeparatedTitle ? 'none' : `url(${brush})`,
                            backgroundSize: { xs: '200px', md: '270px' },
                            backgroundPosition: { xs: 'center', md: 'left' },
                            backgroundRepeat: 'no-repeat',
                            backgroundPositionY: 75
                        }}
                    >
                        {hasSeparatedTitle ? (
                            <>
                                <Box component="span" sx={{ display: 'block' }}>
                                    {introTitleFirstLine}
                                </Box>
                                <Box
                                    component="span"
                                    aria-hidden="true"
                                    style={{
                                        marginTop: '4px',
                                        marginBottom: '20px',
                                        transform: 'translateY(-10px)'
                                    }}
                                    sx={{
                                        display: 'block',
                                        width: { xs: '150px', sm: '185px', md: '205px' },
                                        height: { xs: '8px', md: '10px' },
                                        mx: { xs: 'auto', md: 0 },
                                        backgroundImage: `url(${brush})`,
                                        backgroundSize: '100% 100%',
                                        backgroundPosition: 'left center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                />
                                <Box component="span" sx={{ display: 'block' }}>
                                    {introTitleRemainingLines.join('\n')}
                                </Box>
                            </>
                        ) : introTitle}
                    </Typography>

                    <Typography
                        color='#4E433C'
                        sx={{
                            width: '100%',
                            pl: { xs: 0, md: '4px' },
                            textAlign: { xs: 'center', md: 'left' },
                            fontSize: { xs: '16px', sm: '18px', md: '24px' },
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: '128%',
                            mb: { xs: 3, md: 0 }
                        }}
                    >
                        {t('Introduction.text')}
                    </Typography>
                </Box>

                <Grid item
                    sx={{
                        paddingTop: { xs: 4, md: 10 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: { xs: 'center', md: 'flex-start' },
                        gap: { xs: 2.5, md: 3, xl: 4 }
                    }}
                >
                    {/*
                    <Link href="https://apps.apple.com/hk/app/levav/id6754378820" sx={{ display: 'block' }}>
                        <img
                            src={AppStoreLogo}
                            alt="AppStore"
                            style={{
                                width: isMobile ? '200px' : '220px',
                                height: 'auto',
                                display: 'block'
                            }}
                        />
                    </Link>
                    <Link href='https://play.google.com/store/apps/details?id=com.levav.app' sx={{ display: 'block' }}>
                        <img
                            src={GooglePlayLogo}
                            alt="GooglePlay"
                            style={{
                                width: isMobile ? '200px' : '220px',
                                height: 'auto',
                                display: 'block'
                            }}
                        />
                    </Link>
                    */}
                    <Box
                        aria-hidden="true"
                        sx={{
                            width: isMobile ? '200px' : '220px',
                            aspectRatio: '422 / 140',
                            visibility: 'hidden',
                            flexShrink: 0
                        }}
                    />
                    <Box
                        aria-hidden="true"
                        sx={{
                            width: isMobile ? '200px' : '220px',
                            aspectRatio: '408 / 140',
                            visibility: 'hidden',
                            flexShrink: 0
                        }}
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} md={8} sx={{
                order: { xs: 1, md: 2 },
                mb: { xs: 4, md: 0 },
                position: 'relative'
            }}>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        top: isMobile ? 0 : '12%',
                        overflow: 'hidden',
                        clipPath: isMobile ? 'none' : 'ellipse(65% 150% at 50% -20%)',
                        borderRadius: '24px'
                    }}
                >
                    {/* <Box
                        component="img"
                        src={image_Intro}
                        alt="imag_Intro"
                        sx={{
                            width: '100%',
                            objectFit: 'contain',
                            maxWidth: isMobile ? '300px' : '92%',
                            maxHeight: '75vh',
                            display: 'block',
                            margin: isMobile ? '0 auto' : 'initial',
                            borderRadius: '24px',
                            transform: 'translate(4%, -4%)',
                            // 应用刚刚定义的进场动画，使用 cubic-bezier 曲线让它“丝滑”地浮出
                            animation: `${imageReveal} 1.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards`
                        }}
                    /> */}
                </Box>
            </Grid>
        </Grid>
    );
}
